module.exports = __webpack_public_path__ + "media/images/flags/MC-659aa3aa516094d29addce418b7fbdef.svg";